// develop 의 펀드 · 지수 · 부동산 화면이 쓰는 recoil atom.
// uschool 의 `states/asset.ts` 는 develop 의 `states/asset.tsx` 와 다른 파일이라
// 이 atom 들이 없다. 옮겨온 화면과 함께 둔다. 정리는 P3.
import { atom } from "recoil";

export const isKrwCheckedState = atom({
  key: "isKrwCheckedState",
  default: false,
});

export const KrwChartDataState = atom<any>({
  key: "KrwChartDataState",
  default: [],
});

export const KrwChartIndexState = atom<any>({
  key: "KrwChartIndexState",
  default: [],
});
